import { css } from "@emotion/css";
import { Divider } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { DeploymentFreezeDetailEnvironment, DeploymentFreezeScopeDetail, ProjectResource } from "@octopusdeploy/octopus-server-client";
import pluralize from "pluralize";
import React from "react";
import type { DoBusyTask } from "~/components/DataBaseComponent";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import { NoResults } from "~/components/NoResults/NoResults";
import { FormSectionHeading } from "~/components/form/index";
import { DeploymentFreezeScopeTable } from "./DeploymentFreezeScopeTable";
import type { DeploymentFreezeModel } from "./EditDeploymentFreeze";
import { ProjectFreezeEnvironmentSection } from "./ProjectFreezeEnvironmentSection";
import ConnectFreezeProjectsDialog from "./ScopeConnectDialog/ConnectFreezeProjectsDialog";
interface FreezeProjectScopeSectionProps {
    model: DeploymentFreezeModel;
    project?: ProjectResource;
    deploymentFreezeId?: string;
    focussedScopeCellId: string;
    onConnected: (freeze: DeploymentFreezeModel) => void;
    onProjectEnvironmentUpdate: (project: DeploymentFreezeScopeDetail, selectedEnvironments: DeploymentFreezeDetailEnvironment[]) => Promise<boolean>;
    onProjectRemove: (project: DeploymentFreezeScopeDetail) => void;
    onFocusedScopeCell: (id: string) => void;
    onScopeCellLostFocus: () => void;
    doBusyTask: DoBusyTask;
}
export const FreezeProjectScopeSection: React.FC<FreezeProjectScopeSectionProps> = ({ model, deploymentFreezeId, focussedScopeCellId, onConnected, onProjectEnvironmentUpdate, onProjectRemove, onFocusedScopeCell, onScopeCellLostFocus, doBusyTask, project, }) => {
    const buildProjectScopeSummary = () => (model.projectScope.length > 0 ? `${pluralize("project", model.projectScope.length, true)} assigned` : "Assign projects to this deployment freeze.");
    return (<>
            {project ? (<ProjectFreezeEnvironmentSection deploymentFreeze={model} onEnvironmentUpdate={onProjectEnvironmentUpdate} updateFreezeModel={onConnected} doBusyTask={doBusyTask} project={project}/>) : (<div>
                    <FormSectionHeading title="Project Scope" key="projectScope"/>
                    <div>
                        <div className={styles.connectScopesRow}>
                            <span>{buildProjectScopeSummary()}</span>
                            {model.projectScope.length === 0 && <NoResults />}
                            <OpenDialogButton label="Assign Projects">
                                <ConnectFreezeProjectsDialog deploymentFreeze={model} onConnected={onConnected} alreadyConnectedProjectsIds={model.projectScope.map((s) => s.Id)}/>
                            </OpenDialogButton>
                        </div>
                        {model.projectScope.length > 0 && (<>
                                <Divider />
                                <DeploymentFreezeScopeTable key="scopeTableProject" scopeType="Project" scopeDetails={model.projectScope} onEnvironmentUpdate={onProjectEnvironmentUpdate} onRemove={onProjectRemove} doBusyTask={doBusyTask} focussedScopeCellId={focussedScopeCellId} onFocusedScopeCell={onFocusedScopeCell} onScopeCellLostFocus={onScopeCellLostFocus} deploymentFreezeId={deploymentFreezeId}/>
                            </>)}
                    </div>
                </div>)}
        </>);
};
FreezeProjectScopeSection.displayName = "FreezeProjectScopeSection"
const styles = {
    connectScopesRow: css({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: space[16],
    }),
};
